// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"7a2dbd7f","392":"9130fdd3","426":"d83ce6f5"}[chunkId] + ".chunk.css";
};